import React, { useState } from 'react';
import { useDispatch, useSelector } from "react-redux";
import { add_booking } from '../redux/booking/actions';

function InputForm() {
    //States
    const [destinationFrom, setDestinationFrom] = useState(null);
    const [destinationTo, setDestinationTo] = useState(null);
    const [journeyDate, setJourneyDate] = useState(null);
    const [guestsNumber, setGuestsNumber] = useState(null);  //1,2,3,4
    const [className, setClassName] = useState(null);   //Business, Economy


    //Hooks
    const dispatch = useDispatch();
    const bookingList = useSelector((state) => state.bookings.bookingList);
    console.log(bookingList.length);


    //Functions
    function handleChange(event) {
        const { name, value } = event.target;
        if (name === 'from') {
            setDestinationFrom(value)
        } else if (name === 'to') {
            setDestinationTo(value);
        } else if (name === 'date') {
            setJourneyDate(value);
        } else if (name === 'guests') {
            setGuestsNumber(value);
        } else if (name === 'ticketClass') {
            setClassName(value);
        }
    }



    const handleSubmit = (event) => {
        event.preventDefault();
        if (destinationFrom && destinationTo && journeyDate && guestsNumber && className) {
            const payload = { destinationFrom, destinationTo, journeyDate, guestsNumber, className };
            dispatch(add_booking(payload));
        }
    }

    return (
        <div className="mt-[160px] mx-4 md:mt-[160px] relative">
            <div className="bg-white rounded-md max-w-6xl w-full mx-auto">
                <form className="first-hero lws-inputform">

                    <div className="des-from">
                        <p>Destination From</p>
                        <div className="flex flex-row">
                            <img src="/images/icons/Frame.svg" alt="" />
                            <select className="outline-none px-2 py-2 w-full" name="from" id="lws-from" required onChange={handleChange}>
                                <option value="" hidden>Please Select</option>
                                <option value="dhaka">Dhaka</option>
                                <option value="sylhet">Sylhet</option>
                                <option value="saidpur">Saidpur</option>
                                <option value="cox'sbazar">Cox's Bazar</option>
                            </select>
                        </div>
                    </div>


                    <div className="des-from">
                        <p>Destination To</p>
                        <div className="flex flex-row">
                            <img src="/images/icons/Frame.svg" alt="" />
                            <select className="outline-none px-2 py-2 w-full" name="to" id="lws-to" required onChange={handleChange}>
                                <option value="" hidden>Please Select</option>
                                <option value="dhaka">Dhaka</option>
                                <option value="sylhet">Sylhet</option>
                                <option value="saidpur">Saidpur</option>
                                <option value="cox'sbazar">Cox's Bazar</option>
                            </select>
                        </div>
                    </div>


                    <div className="des-from">
                        <p>Journey Date</p>
                        <input type="date" className="outline-none px-2 py-2 w-full date" name="date" id="lws-date" required onChange={handleChange} />
                    </div>


                    <div className="des-from">
                        <p>Guests</p>
                        <div className="flex flex-row">
                            <img src="/images/icons/Vector (1).svg" alt="" />
                            <select className="outline-none px-2 py-2 w-full" name="guests" id="lws-guests" required onChange={handleChange}>
                                <option value="" hidden>Please Select</option>
                                <option value="1">1 Person</option>
                                <option value="2">2 Persons</option>
                                <option value="3">3 Persons</option>
                                <option value="4">4 Persons</option>
                            </select>
                        </div>
                    </div>


                    <div className="des-from !border-r-0">
                        <p>Class</p>
                        <div className="flex flex-row">
                            <img src="/images/icons/Vector (3).svg" alt="" />
                            <select className="outline-none px-2 py-2 w-full" name="ticketClass" id="lws-ticketClass" required onChange={handleChange}>
                                <option value="" hidden>Please Select</option>
                                <option value="business">Business</option>
                                <option value="economy">Economy</option>
                            </select>
                        </div>
                    </div>

                    <button className="addCity" type="submit" id="lws-addCity" disabled={bookingList.length > 2} onClick={(e) => handleSubmit(e)}>
                        <svg width="15px" height="15px" fill="none" viewBox="0 0 24 24" strokeWidth="2" stroke="currentColor" >
                            <path strokeLinecap="round" strokeLinejoin="round" d="M12 4.5v15m7.5-7.5h-15" />
                        </svg>
                        <span className="text-sm">Book</span>
                    </button>
                </form>
            </div>
        </div>
    )
}

export default InputForm